import {
  CartQuoteServices,
  CartUpdateServices,
  CartFulfillServices,
  FlightServices,
  getObjectKeysAsObject,
  FlightPassengerServices,
  SeatServices,
  ContactInformationServices,
  PassportServices,
  CardPaymentServices,
} from "@capone/checkout";
import { checkoutServices } from "./common";

export const Services: any = {
  ...CartFulfillServices,
  ...CartQuoteServices,
  ...CartUpdateServices,
  ...checkoutServices,
  ...FlightServices,
  ...ContactInformationServices,
  ...FlightPassengerServices,
  ...PassportServices,
  ...SeatServices,
  ...CardPaymentServices,
};

export const ServiceTypes = getObjectKeysAsObject(Services);
